import { cn } from "@/lib/utils"
import { cva, type VariantProps } from "class-variance-authority"

// §02.5 Spinner: 20 default, 14 in buttons, 1.5px stroke, 900ms linear.
// The arc is ink (currentColor), never accent: loading is not one of the
// six accent roles (§01.2). Reduced motion turns it into a static ring via
// the global motion-reduce rules in app/globals.css.
const spinnerVariants = cva(
  "animate-spin [animation-duration:900ms]",
  {
    variants: {
      variant: {
        ring: "rounded-[var(--radius-pill)] border-[1.5px] border-current border-t-transparent",
      },
      size: {
        xs: "size-3.5",
        sm: "size-4",
        md: "size-5",
        lg: "size-8",
        xl: "size-10",
      },
    },
    defaultVariants: {
      variant: "ring",
      size: "md",
    },
  }
)

interface SpinnerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof spinnerVariants> {}

function Spinner({ className, variant, size, ...props }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn(spinnerVariants({ variant, size }), className)}
      {...props}
    />
  )
}

// eslint-disable-next-line react-doctor/only-export-components
export { Spinner, spinnerVariants }
